

export default function toggleFullScreen() {
    if (!document.fullscreenElement) {
        if(document.documentElement.requestFullscreen){
          document.documentElement.requestFullscreen()
        }
        else if(document.documentElement.webkitRequestFullScreen){
          document.documentElement.webkitRequestFullScreen()
        }
        else {
          console.log('no fullscreen possible')
        }
        
        
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen(); 
      }
    }
  }


// WEBPACK FOOTER //
// ./src/utils/toggleFullscreen.js